import moment from "moment";
import { PeriodOptions } from "PFComponents/calendar/parts/calendar_periods/calendar_periods.types";
import { useTranslation } from "react-i18next";

import { DATE_MONTH_YEAR } from "./date";

export const usePeriods = (): PeriodOptions => {
  const { t } = useTranslation("bookingModule");

  return {
    manual: {
      header: t("calendar.options.manual"),
      range: {
        startDate: moment(),
        endDate: moment()
      },
      label: ""
    },

    lastWeek: {
      header: t("calendar.options.lastWeek"),
      range: {
        startDate: moment().subtract(1, "weeks").startOf("week"),
        endDate: moment().subtract(1, "weeks").endOf("week")
      },
      label: `${moment().subtract(1, "weeks").startOf("week").format("ll")} - ${moment()
        .subtract(1, "weeks")
        .endOf("week")
        .format("ll")}`
    },
    thisWeek: {
      header: t("calendar.options.thisWeek"),
      range: {
        startDate: moment().startOf("week"),
        endDate: moment().endOf("week")
      },
      label: `${moment().startOf("week").format("ll")} - ${moment().endOf("week").format("ll")}`
    },
    nextWeek: {
      header: t("calendar.options.nextWeek"),
      range: {
        startDate: moment().add(1, "weeks").startOf("week"),
        endDate: moment().add(1, "weeks").endOf("week")
      },
      label: `${moment().add(1, "weeks").startOf("week").format("ll")} - ${moment()
        .add(1, "weeks")
        .endOf("week")
        .format("ll")}`
    },

    lastMonth: {
      header: t("calendar.options.lastMonth"),
      range: {
        startDate: moment().subtract(1, "month").startOf("month"),
        endDate: moment().subtract(1, "month").endOf("month")
      },
      label: `${moment().subtract(1, "month").format(DATE_MONTH_YEAR)}`
    },
    thisMonth: {
      header: t("calendar.options.thisMonth"),
      range: {
        startDate: moment().startOf("month"),
        endDate: moment().endOf("month")
      },
      label: `${moment().format(DATE_MONTH_YEAR)}`
    },
    nextMonth: {
      header: t("calendar.options.nextMonth"),
      range: {
        startDate: moment().add(1, "month").startOf("month"),
        endDate: moment().add(1, "month").endOf("month")
      },
      label: `${moment().add(1, "month").format(DATE_MONTH_YEAR)}`
    },

    lastQuarter: {
      header: t("calendar.options.lastQuarter"),
      range: {
        startDate: moment().subtract(1, "quarter").startOf("quarter"),
        endDate: moment().subtract(1, "quarter").endOf("quarter")
      },
      label: `Q${moment().subtract(1, "quarter").quarter()} ${moment().subtract(1, "quarter").year()}`
    },
    thisQuarter: {
      header: t("calendar.options.thisQuarter"),
      range: {
        startDate: moment().startOf("quarter"),
        endDate: moment().endOf("quarter")
      },
      label: `Q${moment().quarter()} ${moment().format("YYYY")}`
    },
    nextQuarter: {
      header: t("calendar.options.nextQuarter"),
      range: {
        startDate: moment().add(1, "quarter").startOf("quarter"),
        endDate: moment().add(1, "quarter").endOf("quarter")
      },
      label: `Q${moment().add(1, "quarter").quarter()} ${moment().add(1, "quarter").year()}`
    },

    lastYear: {
      header: t("calendar.options.lastYear"),
      range: {
        startDate: moment().subtract(1, "year").startOf("year"),
        endDate: moment().subtract(1, "year").endOf("year")
      },
      label: `${moment().subtract(1, "year").format("YYYY")}`
    },
    thisYear: {
      header: t("calendar.options.thisYear"),
      range: {
        startDate: moment().startOf("year"),
        endDate: moment().endOf("year")
      },
      label: `${moment().format("YYYY")}`
    },
    nextYear: {
      header: t("calendar.options.nextYear"),
      range: {
        startDate: moment().add(1, "year").startOf("year"),
        endDate: moment().add(1, "year").endOf("year")
      },
      label: `${moment().add(1, "year").format("YYYY")}`
    }
  };
};
